module.exports = __webpack_public_path__ + "static/media/editor.169739f4.jpeg";